import { create } from "zustand";

interface VersionState {
	newVersionAvailable: boolean;
	markNewVersionAvailable: () => void;
}

export const useVersionStore = create<VersionState>((set) => ({
	newVersionAvailable: false,
	markNewVersionAvailable: () => set({ newVersionAvailable: true }),
}));

export function useNewVersionAvailable(): boolean {
	return useVersionStore((state) => state.newVersionAvailable);
}
